'use strict';

var clone = require('./clone');
var matches = require('./matches');
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
  var i, pattern, patternLength, clonedCardConfiguration;
  for (i = 0; i < cardConfiguration.patterns.length; i++) {
    pattern = cardConfiguration.patterns[i];
    if (!matches(cardNumber, pattern)) {
      continue;
    }
    clonedCardConfiguration = clone(cardConfiguration);
    if (Array.isArray(pattern)) {
      patternLength = String(pattern[0]).length;
    } else {
      patternLength = String(pattern).length;
    }
    if (cardNumber.length >= patternLength) {
      clonedCardConfiguration.matchStrength = patternLength;
    }
    results.push(clonedCardConfiguration);
    break;
  }
}
module.exports = addMatchingCardsToResults;